import React from "react";
import type {TFunction} from "i18next";
import ReactMarkdown from "react-markdown";
import Button from "../../ui/button";
import classes from "./WebGLUnavailableModal.module.css";

type ModalAdd = (opts: {
  id?: string;

  className?: string;
  adaptive?: boolean;
  size?: "s" | "m" | "l" | "xl";
  header?: React.ReactNode;
  content: React.ReactNode;
  footer?: React.ReactNode;
  hideCloseButton?: boolean;
  stopCloseOnOuterClick?: boolean;
}) => {
  id: string;
  remove: () => void;
};

function webglUnavailableMarkdown(t: TFunction): string {
  return [
    t("player.webglUnavailable.intro"),
    "",
    `- ${t("player.webglUnavailable.reasonHardwareAccel")}`,
    `- ${t("player.webglUnavailable.reasonBrowser")}`,
    `- ${t("player.webglUnavailable.reasonEnvironment")}`,
    `- ${t("player.webglUnavailable.reasonDrivers")}`
  ].join("\n");
}

export function openWebGLUnavailableModal(add: ModalAdd, t: TFunction): void {
  const markdown = webglUnavailableMarkdown(t);
  const modalHandle = add({
    size: "m",
    header: <>{t("player.webglUnavailable.header")}</>,
    content: (
      <ReactMarkdown className={classes.markdown}>{markdown}</ReactMarkdown>
    ),
    footer: (
      <div className={classes.footerActions}>
        <Button color="primary" onClick={() => modalHandle.remove()}>
          {t("player.webglUnavailable.ok")}
        </Button>
      </div>
    )
  });
}